import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import topupImage from "../assets/images/dashboard/topup.png";
import buyCryptoImage from "../assets/images/dashboard/buyCrypto.png";
import eightPayImage from "../assets/images/dashboard/eightPay.png";
import chatUsImage from "../assets/images/dashboard/chatUs.png";
import topupImageSm from "../assets/images/dashboard/topup-sm.png";
import buyCryptoImageSm from "../assets/images/dashboard/deposit-sm.png";
import eightPayImageSm from "../assets/images/dashboard/88pay.png";
import chatUsImageSm from "../assets/images/dashboard/buy-sm.png";
import { useFeatureFlagsByCategory } from "../hooks/query/queries";

export function QuickActions() {
  const { data: featureFlags } = useFeatureFlagsByCategory("mainFeatures");

  const actions = [
    featureFlags?.deposit && {
      title: "Top Up",
      description: "Add cash to your wallet",
      image: topupImage,
      smImage: topupImageSm,
      smText: "Top-up",
    },
    featureFlags?.deposit && {
      title: "Deposit Funds",
      description: "Fund your wallet",
      image: buyCryptoImage,
      smImage: buyCryptoImageSm,
      smText: "Deposit",
    },
    featureFlags?.buyCrypto && {
      title: "Buy Crypto",
      description: "Craft your crypto portfolio",
      image: eightPayImage,
      smImage: chatUsImageSm,
      smText: "Buy",
    },
    featureFlags?.eightPay && {
      title: "88Pay",
      description: "Seamless payments",
      image: chatUsImage,
      smImage: eightPayImageSm,
      smText: "88Pay",
    },
  ].filter(Boolean);

  return (
    <div className="grid grid-cols-4 lg:grid-cols-4 gap-3 lg:gap-4 justify-items-center lg:justify-items-stretch">
      {actions.map((action) => (
        <ActionButton key={action.title} {...action} />
      ))}
    </div>
  );
}

const ActionButton = ({ title, description, image, smImage, smText }) => {
  const navigate = useNavigate();

  const handleClick = (title) => {
    let selectedTab = null;
    let parentTab = null;
    let route = "/";

    switch (title) {
      case "Top Up":
        selectedTab = "deposit";
        parentTab = "withdraw-deposit";
        route = "/trading/digitalWallet";
        break;
      case "Deposit Funds":
        selectedTab = "deposit";
        parentTab = "withdraw-deposit";
        route = "/trading/digitalWallet";
        break;
      case "Buy Crypto":
        selectedTab = "Buy";
        parentTab = "buy-sell";
        route = "/trading/digitalWallet";
        break;
      case "88Pay":
        selectedTab = "Pay";
        parentTab = "80eightpay";
        route = "/trading/digitalWallet";
        break;
      default:
        route = "/";
    }

    navigate(route, {
      state: {
        selectedTab,
        parentTab,
      },
    });
  };

  return (
    <>
      <Button
        onClick={() => handleClick(title)}
        variant="outline"
        className="lg:hidden relative border-0 bg-transparent text-white hover:text-white/80 flex flex-col items-center justify-center gap-2 h-auto py-3 px-3 overflow-hidden w-full max-w-[80px]"
      >
        <div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-white/10 border-[1px] border-[#ffffff54]">
          <img
            src={smImage}
            alt={title}
            className="h-6 w-6 relative z-10 object-contain"
          />
        </div>
        <div className="text-[12px] font-normal text-white text-center relative z-10 leading-tight">
          {smText}
        </div>
      </Button>

      <Button
        onClick={() => handleClick(title)}
        variant="outline"
        className="hidden lg:flex relative border-[#ffffff54] text-white hover:text-white/50 gap-4 items-center justify-between h-auto py-4 px-4 overflow-hidden backdrop-blur-[16px]"
        style={{
          background:
            "radial-gradient(196.29% 458.78% at -8.86% -12.86%, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
        }}
      >
        <img
          src={image}
          alt={title}
          className="h-[32px] w-[32px] mb-1 relative z-10 object-contain"
        />
        <div className="text-left w-[80%] relative z-10">
          <div className="text-[16px] font-semibold text-white">{title}</div>
          <div className="text-[12px] text-[#EBE9EF] text-wrap whitespace-normal">
            {description}
          </div>
        </div>
        <div className="border relative z-10 rounded-full p-2 border-accent/30">
          <ArrowRight />
        </div>
      </Button>
    </>
  );
};
